import NewPatientFlow from "../../Types/NewPatientFlow";
import BaseExperimentalFlowResolver from "./BaseExperimentalFlowResolver";
import ExperimentKey from "./ExperimentKey";
import NoConfirmationNewPatientFlow from "./NoConfirmationNewPatientFlow";

/** Resolves the no-confirmation new patient flow when the confirmation-page-removal experiment is active. */
class NoConfirmationNewPatientFlowResolver extends BaseExperimentalFlowResolver {
  constructor(isCustomerPreQualified: boolean, experimentKey: ExperimentKey) {
    super(
      new NoConfirmationNewPatientFlow(isCustomerPreQualified),
      new NewPatientFlow(isCustomerPreQualified),
      experimentKey
    );
  }
}

export default NoConfirmationNewPatientFlowResolver;
